import { Component, OnInit } from "@angular/core";
import { DocumentCategoryService } from "../../../../service/repository/document-category.service";
import { DocumentCategoryView } from "../../../../domain/documentCategoryView";
import { DocumentService } from "../../../../service/repository/document.service";
import { Document as Doc } from "../../../../domain/document";
import {
  animate,
  state,
  style,
  transition,
  trigger
} from "@angular/animations";
import { ConfirmationService } from "primeng/primeng";
import { MessageSeverity } from "../../../../../core/commons/message-severity";
import { GlobalAppService } from "../../../../../core/commons/global-app.service";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { DocumentCategory } from "../../../../domain/documentCategory";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/observable/of";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { Keyword } from "app/fiscalia/domain/keyword";

@Component({
  selector: "document-explorer",
  templateUrl: "./document-explorer.component.html",
  styleUrls: ["./document-explorer.component.scss"],
  animations: [
    trigger("showDetail", [
      state("void", style({ right: "-170px" })),
      state("hide", style({ right: "-170px" })),
      state("show", style({ right: "0" })),
      transition("* => show", [animate("195ms ease-in-out")]),
      transition("show => hide", [animate("140ms ease-in-out")])
    ])
  ]
})
export class DocumentExplorerComponent implements OnInit {
  breadCrumb: DocumentCategory[] = []; //Cadena que se mostrara cuando se selecciona una categoria.

  categorySelected: DocumentCategoryView = null; //Categoria que se muestra en el explorador.

  categoryToRefresh: DocumentCategoryView = null; //Categoria que puede cambiar cuando se modifica un documento

  categories: DocumentCategoryView[] = []; //Listado de sub categorias de la categoria seleccionada.

  categoryEmpty: boolean = false; // Filtro para mostrar el mensaje de una categoria vacia.

  documents: Doc[] = []; //Listado de documentos por categoria.

  documentSelected: Doc = null; //Documento seleccionado.

  createDocument: boolean = false;

  detailState = "hide"; //Estado del detalle de un documento que fue seleccionado, "hide" => "show".

  documentSearch: Subject<string> = new Subject(); //Obervable donde se envia la cadena de busqueda ingresada en el buscador.

  isSearch: boolean = false; // Booleano usado para saber si se esta llevando a cabo una busqueda.

  showCategoryForm: boolean = false; //Booleano que permite mostrar el modal para crear una nueva carpeta.

  updateCategory: boolean = false; //Booleano para indicar si se va a modificar una categoria existente.

  categoryToUpdate: DocumentCategory = null;

  showHiddenCategories: boolean = false;

  // filter keywords
  formGroup: FormGroup;
  filteredOptions: Keyword[];

  constructor(
    private categoryService: DocumentCategoryService,
    private documentService: DocumentService,
    private confirmationService: ConfirmationService,
    private messageService: GlobalAppService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    // Search keywords
    this.formGroup = this.fb.group({
      search: new FormControl("")
    });


    this.categoryService.categoryToShow.asObservable().subscribe(() => {
        this.formGroup.get('search').reset();
    })

    this.formGroup.controls["search"].valueChanges
      .debounceTime(400)
      .subscribe(() => this.applyFilter());
    // End search keywords

    this.categorySelected = null;

    if (this.categoryService.authService.isLoggedIn()) {
      this.categoryService.authService.user.subscribe(u => {
        this.showHiddenCategories =
          u.hasFx("Category.CHANGECATEGORYVISIBILITY") ||
          u.hasFx("Document.CREATE");
      });
    }

    this.categoryService.getCategoryToShow().subscribe(c => {
      this.categoryService.loadingSubject.next(false);
      this.isSearch = false;
      this.documents = c.documents;
      this.categories = c.subCategories;
      this.categorySelected = c;
      this.breadCrumb = this.categorySelected.getBreadCrumb();
      this.categoryEmpty = c.isEmpty();
    });


    let search = this.documentSearch
      .asObservable()
      .debounceTime(300)
      .do(term => (this.isSearch = true))
      .switchMap(term => {
        this.unsetDocumentSelected();
        this.categoryService.loadingSubject.next(true);
        if (term != "") {
          this.categories = [];
          // search with categorySelected
          if (this.categorySelected != null) {
            return this.documentService.findByValueAndCategory(
              term,
              this.categorySelected.id
            );
          } else {
            return this.documentService.findByValueAndCategory(term, null);
          }
        } else {
          this.categoryService.loadingSubject.next(false);
          this.breadCrumb = [];
          this.isSearch = false;
          if (this.categorySelected) {
            this.openCategory(this.categorySelected);
          } else this.documents = [];
          return Observable.of([]);
        }
      });

    search
      .filter(docs => docs.length == 0 && this.isSearch)
      .subscribe(docs => {
        this.documents = [];
        this.categoryService.loadingSubject.next(false);
      });

    search
      .filter(docs => docs.length > 0)
      .subscribe(docs => {
        this.documents = docs;
        this.categoryService.loadingSubject.next(false);
      });
  }

  public search(val: string): void {
    this.documentSearch.next(val);
  }

  public setDocumentSelected(d: Doc): void {
    this.documentSelected = d;
    this.createDocument = false;
    this.categoryToRefresh = this.categorySelected;
  }

  public unsetDocumentSelected(): void {
    this.closeForm();
    this.detailState = "hide";
  }

  public openCategory(c: DocumentCategoryView) {
    this.categoryService.setCategoryToShow(c);
   // if (this.createDocument) this.closeForm();
  }

  public newDocument() {
    this.documentSelected = new Doc();
    this.createDocument = true;
    this.detailState = "show";
  }

  /**
   * Oculta el formulario o la pestaña que muestra el detalle de un documento.
   */
  public closeForm(): void {
    if (this.createDocument) this.createDocument = false;
    this.documentSelected = null;
  }

  /**
   * Vuelve a cargar los documentos para una categoria
   */
  public refreshDocuments(): void {
    this.createDocument = false;
    this.categorySelected.loadedDocuments = false;
    this.categoryService.setCategoryToShow(this.categorySelected);

    if (this.categoryToRefresh) {
      this.categoryToRefresh.loadedDocuments = false;
      this.categoryToRefresh.loadedSubCategories = false;
      this.categoryToRefresh = null;
    }

    this.closeForm();
  }

  public newCategory() {
    this.showCategoryForm = true;
    this.categoryToUpdate = null;
  }

  /**
   * Muestra el modal para cambiar el nombre de una categoria.
   */
  public changeNameToCategory() {
    this.showCategoryForm = true;
    this.categoryToUpdate = new DocumentCategory(this.categorySelected);
  }

  /**
   * Cambia la visibilidad de una carpeta, la puede ocultar o mostrar.
   */
  public changeVisibilityToCategory() {
    this.messageService.setLoading(true);
    this.categoryService.loadingSubject.next(true);
    this.categoryService
      .changeCategoryVisibility(this.categorySelected.id)
      .subscribe(res => {
        this.categoryService.loadingSubject.next(false);
        this.categorySelected.visible = !this.categorySelected.visible;
        this.messageService.setLoading(false);
      });
  }

  public deleteCategory() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la carpeta?",
      icon: "fa ui-icon-delete-forever",
      accept: () => {
        this.messageService.setLoading(true);
        this.categoryService.loadingSubject.next(true);
        this.categoryService.delete(this.categorySelected).subscribe(
          res => {
            this.categoryService.loadingSubject.next(false);
            if (this.categorySelected.parentCategory) {
              let c = this.categorySelected
                .parentCategory as DocumentCategoryView;
              c.loadedSubCategories = false;
              c.loadedDocuments = false;
              this.categoryService.setCategoryToShow(c);
            } else {
              this.categoryService.getParentCategories();
              this.categorySelected = null;
              this.breadCrumb = [];
              this.categoryEmpty = false;
            }
            this.messageService.setLoading(false);
            this.messageService.sendMsg(
              MessageSeverity.SUCCESS,
              "Eliminado",
              "Se ha eliminado la carpeta."
            );
          },
          error => {
            this.messageService.sendMsg(
              MessageSeverity.ERROR,
              "Error",
              "No ha sido posible eliminar la carpeta."
            );
          }
        );
      }
    });
  }

  public refreshFolder(c: DocumentCategory) {
    if (this.categoryToUpdate) {
      this.categorySelected.name = c.name;
      this.breadCrumb = this.categorySelected.getBreadCrumb();
    }

    if (this.categorySelected) {
      this.categorySelected.loadedSubCategories = false;
      this.categoryService.setCategoryToShow(this.categorySelected);
    }
  }

  /*
    Search keywords
  */
  applyFilter() {
    let keywordValue = this.formGroup.controls["search"].value;
    this.documentService.findBykeyWord(keywordValue).subscribe(data => {
      this.filteredOptions = data;
    });
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      if (this.formGroup.controls["search"].value != "") {
        this.search(this.formGroup.controls["search"].value);
      } else {
          this.refreshFolder(this.categoryToRefresh);
      }
    }
  }

  /*
   Clear inputs
 */
  isClearIconVisible(): boolean {
    if (this.formGroup.controls["search"].value != "") return true;
    else return false;
  }

  clearInputValue() {
    this.formGroup.patchValue({
      search: ""
    });
    this.refreshFolder(this.categoryToRefresh);
  }

  goToRoot(){
      this.categoryService.getParentCategories();
      this.categorySelected = null;
      this.breadCrumb = [];
      this.categoryEmpty = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/repository/explorer/document-explorer/document-explorer.component.ts